import { render, staticRenderFns } from "./ErrorMessagesBlock.vue?vue&type=template&id=54860780"
import script from "./ErrorMessagesBlock.vue?vue&type=script&lang=js"
export * from "./ErrorMessagesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports